export default __webpack_public_path__ + "static/media/user.28c8ac9b.svg";